import { MapActions } from "../reducers/MapReducer"
import store from '../store'

export const centerMap = (position: { lat: number, lng: number }) => {
    store.dispatch({ type: MapActions.SetCenter, payload: position })
}

